import { createApi } from '@reduxjs/toolkit/query/react';
import apiRoutesV2 from 'src/config/api/routes';
import { appBaseQuery } from 'src/modules/shared/slices/helpers';
import { SearchContent } from './type';

const mockData = [
  {
    chapters: [
      {
        number: '1',
        title: 'Introduction to Mathematics',
      },
    ],
    trajectory: {
      number: '1.1.1.1',
      title: 'Addition and Subtraction',
    },
  },
  {
    chapters: [
      {
        number: '2',
        title: 'Algebra Basics',
      },
      {
        number: '2.1',
        title: 'Variables and Expressions',
      },
    ],
    trajectory: {
      number: '2.2.1',
      title: 'Linear Equations',
    },
  },
  {
    chapters: [
      {
        number: '3',
        title: 'Geometry',
      },
      {
        number: '3.1',
        title: 'Angles and Lines',
      },
      {
        number: '3.1.1',
        title: 'Parallel Lines',
      },
    ],
    trajectory: {
      number: '3.2.1',
      title: 'Triangles and Circles',
    },
  },
  {
    chapters: [
      {
        number: '4',
        title: 'Introduction to Calculus',
      },
      {
        number: '4.1',
        title: 'Limits',
      },
    ],
    trajectory: {
      number: '4.2.1',
      title: 'The Power Rule',
    },
  },
  {
    chapters: [
      {
        number: '5',
        title: 'Statistics Basics',
      },
    ],
    trajectory: {
      number: '5.1.1',
      title: 'Probability Distributions',
    },
  },
];

export const searchContentApi = createApi({
  reducerPath: 'searchContentApi',
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    postSearchResult: builder.mutation<SearchContent[], { bookId: string; body: any }>({
      query: ({ bookId, body }) => ({
        url: apiRoutesV2.searchContent(bookId),
        method: 'POST',
        body,
      }),
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return mockData;
      },
    }),
  }),
});

export const { usePostSearchResultMutation } = searchContentApi;
